export function setToLocalStorage(property, value) {
	localStorage.setItem(property, value);
}

export function getFromLocalStorage(property) {
	return localStorage.getItem(property);
}
